import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class AuthGuard {

  constructor(private readonly router: Router) {

  }

  canActivate(): boolean {
    const currentUser = localStorage.getItem('current_user');
    const accessToken = localStorage.getItem('access_token');

    if (!currentUser || !accessToken) {
      this.router.navigate(['login']);
      return false;
    }

    try {
      JSON.parse(currentUser);
    } catch {
      this.router.navigate(['login']);
      return false;
    }

    return true;
  }
}
